/****************************************************
 * Module Name:  lotCreationProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class LotCreationProxy {
  static GetAllLotCreation = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lotcreation",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllLotCreationByPendingWeight = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lotcreation/pendingweight",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleLotCreation = (lotcreationId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/lotcreation/${lotcreationId}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckLotCreationAvailable = (lotcreation, callback) => {
    let params = {
      lotid: lotcreation,
    };

    restAPICall(
      Constants.MANAGER_URL + "/lotcreation/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddLotCreation = (lotcreation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lotcreation",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(lotcreation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddLotCreationViaMultipleLots = (data, userid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/lotcreation/multiple/${userid}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateLotCreation = (lotcreation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lotcreation",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(lotcreation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteLotCreation = (lotcreation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lotcreation",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(lotcreation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetLotDetailsByLotId = (lotid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/lotcreation/audit/${lotid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static SplitLotInToMultipleLots = (data, userid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/lotcreation/split/${userid}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
